<style src="./CountValues.scss" lang="scss"></style>
<template>
  <section class="count-values">
    <div class="lateral">
      <span class="title">{{ textAbrevMonth }} / {{ year }}</span>
    </div>
    
    <div
      v-if="isWaitingLoad"
      class="waitingload">
      <icon-wait class="icon" />
    </div>
    <div
      v-if="!isWaitingLoad"
      class="info">
      <div class="participation">
        <div class="participated count">
          <span class="value">{{ quotedCountItems | DecimalNumber }}<small class="perc blue">{{ percQuotedCount }}</small></span>
          <span class="title">ITENS COTADOS</span>
        </div>
        <div
          v-show="showQuoted"
          @click="toggleQuoteView"
          class="participated">
          <span class="value currency"><small>R$</small> {{ quotedTotal | CurrencyBR }}<small class="perc blue">{{ percQuotedTotal }}</small></span>
          <span class="title">CUSTO COTADO</span>
        </div>
        <div
          v-show="!showQuoted"
          @click="toggleQuoteView"
          class="participated">
          <span class="value currency"><small>R$</small> {{ costWinnerTotal | CurrencyBR }}<small class="perc blue">{{ percCostTotal }}</small></span>
          <span class="title">CUSTO GANHO</span>
        </div>
      </div>
      <div class="participation">
        <div
          class="participated count">
          <span class="value">{{ wonTotalItems | DecimalNumber }}<small class="perc green">{{ percWonTotalItems }}</small></span>
          <span class="title">ITENS GANHO</span>
        </div>
        <div
          v-show="showProfit"
          @click="toggleProfit"
          class="participated">
          <span class="value currency"><small>R$</small> {{ wonTotal | CurrencyBR }}<small class="perc green">{{ percWonTotal }}</small></span>
          <span class="title">VALOR GANHO</span>
        </div>
        <div
          v-show="!showProfit"
          @click="toggleProfit"
          class="participated">
          <span class="value currency"><small>R$</small> {{ profitTotal | CurrencyBR }}<small class="perc green">{{ percWonTotal }}</small></span>
          <span class="title">LUCRO BRUTO</span>
        </div>
      </div>

      <div class="total">
        <span>ESTIMADO R$ <strong>{{ countParticipatedEstimated | CurrencyBR}}</strong> EM <strong>{{ totalItems | DecimalNumber}}</strong> ITEMS</span>
      </div>
    </div>
  </section>
</template>

<script>
import { CurrencyBR, DecimalNumber } from '@/components/primitives/helpers/filters'
import { IconWait } from '@/components/primitives/icons'

const MONTHS = ['JANEIRO', 'FEVEREIRO', 'MARÇO', 'ABRIL', 'MAIO', 'JUNHO', 'JULHO', 'AGOSTO', 'SETEMBRO', 'OUTUBRO', 'NOVEMBRO', 'DEZEMBRO']

export default {
  name: 'CountValues',
  components: {
    IconWait
  },
  props: {
    isWaitingLoad: false,
    month: {
      default: null
    },
    year: {
      default: null
    },
    totalItems: {
      default: null
    },
    countParticipatedEstimated: {
      default: null
    },
    quotedCountItems: {
      default: null
    },
    quotedTotal: {
      default: null
    },
    wonTotalItems: {
      default: null
    },
    wonTotal: {
      default: null
    },
    costWinnerTotal: {
      default: null
    }
  },
  data: () => ({
    showQuoted: false,
    showProfit: false
  }),
  filters: {
    CurrencyBR,
    DecimalNumber
  },
  computed: {
    percQuotedCount () {
      const calc = ((Number(this.quotedCountItems) * 100) / Number(this.totalItems)).toFixed(1)
      return isNaN(calc) ? '' : `${calc}%`
    },
    percQuotedTotal () {
      const calc = ((Number(this.quotedTotal) * 100) / Number(this.countParticipatedEstimated)).toFixed(1)
      return isNaN(calc) ? '' : `${calc}%`
    },
    percWonTotalItems () {
      const calc = ((Number(this.wonTotalItems) * 100) / Number(this.quotedCountItems)).toFixed(1)
      return isNaN(calc) ? '' : `${calc}%`
    },
    percWonTotal () {
      const calc = (((Number(this.wonTotal) * 100) / Number(this.costWinnerTotal)) - 100).toFixed(1)
      return isNaN(calc) ? '' : `${calc}%`
    },
    percCostTotal () {
      const calc = ((Number(this.costWinnerTotal) * 100) / Number(this.quotedTotal)).toFixed(1)
      return isNaN(calc) ? '' : `${calc}%`
    },
    textAbrevMonth () {
      return MONTHS[Number(this.month) - 1].substring(0, 3)
    },
    textMonth () {
      return MONTHS[Number(this.month) - 1]
    },
    profitTotal () {
      return this.wonTotal - this.costWinnerTotal
    }
  },
  methods: {
    toggleQuoteView () {
      this.showQuoted = !this.showQuoted
    },
    toggleProfit () {
      this.showProfit = !this.showProfit
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/dashboard/components/count-values/CountValues.vue